import { t } from '@lingui/core/macro';
import { CommonMetadataAllowedValuesFilter } from './MetadataAllowedValuesFilter';
export const originalVersionStoredFilterLabel = () => t({
    message: 'Original version stored',
    comment: 'Insights filter: Original version stored',
});
export function OriginalVersionStoredFilter() {
    return (<CommonMetadataAllowedValuesFilter name="OriginalVersionStored" field="metadataDocumentOriginalVersionStored" label={originalVersionStoredFilterLabel()}/>);
}
